import React from 'react';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper } from '../../../components';
import type { ParagraphPracticalInformation as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphPracticalInformationProps {
  id?: string;
  entity: ImmutableEntity<Type>;
}

const ParagraphPracticalInformation: React.FC<ParagraphPracticalInformationProps> = ({
  id,
  entity,
}) => {
  const paragraphPracticalInformation = entity.toJS();
  const title = paragraphPracticalInformation.field_title[0]?.value;
  const label = paragraphPracticalInformation.field_label[0]?.value;
  const media = paragraphPracticalInformation.field_media_item[0];

  const link = paragraphPracticalInformation.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;

  return (
    <div id={id} className="ParagraphSidebar ParagraphPracticalInformation Paper">
      <h3 className="ParagraphPracticalInformation__title">{title}</h3>
      {label && <p className="ParagraphPracticalInformation__label body--small">{label}</p>}

      {media && (
        <DynamicMediaItem
          media={media}
          imageAspectRatio="4_3"
          caption={media.entity.field_caption[0]?.value}
        />
      )}

      {linkUrl && (
        <div className="ParagraphPracticalInformation__link">
          {linkUrl && (
            <ButtonWrapper
              type="textual"
              href={linkUrl}
            >
              {linkTitle}
            </ButtonWrapper>
          )}
        </div>
      )}
    </div>
  );
};

export default ParagraphPracticalInformation;
